import { gql, useQuery } from '@apollo/client';
import { graphql } from '@apollo/client/react/hoc';
import { Alert, AlertDescription, Center } from '@chakra-ui/react';
import { Button, Col, Layout, Row, Typography } from 'antd';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './App.module.scss';
import MovieCredits from './MovieCredits';
const { Content } = Layout;
const { Title } = Typography;

const MOVIE_INFO = gql`
  query MovieInfo($id: String) {
    movieInfo(id: $id) {
      title
      overview
      poster_path
      genres
      release_date
      vote_average
      runtime
      production_companies
      videos {
        id
        key
      }
      movieCredits {
        id
        character
        name
        profile_path
        order
      }
    }
  }
`;

const MovieInfo = () => {
  const [video, setVideo] = useState(null);
  const [size, setSize] = useState('large');
  let { id } = useParams();
  const { loading, error, data } = useQuery(MOVIE_INFO, {
    variables: { id },
  });

  if (loading) return <div className={styles.loader}></div>;
  if (error)
    return (
      <Center>
        <Alert bg="#f9bf3b" color="#000" w={500}>
          <AlertDescription px={1} py={1}>
            An error occurred
          </AlertDescription>
        </Alert>
      </Center>
    );

  function renderVideos(videos) {
    return videos.map(video => {
      return (
        <img
          key={video.id}
          onClick={() => videoDisplay(video.key)}
          className={styles.video_thumbs}
          src={`http://img.youtube.com/vi/${video.key}/0.jpg`}
          alt=""
        />
      );
    });
  }
  function videoDisplay(video) {
    setVideo(video);
  }
  function videoToggle() {
    if (video)
      return (
        <div className={styles.youtube}>
          <h4 onClick={() => videoExit()}>CLOSE</h4>
          <iframe
            width="560"
            height="315"
            src={`//www.youtube.com/embed/${video}`}
            frameborder="0"
            allowfullscreen
            title="Youtube video for movie"
          />
        </div>
      );
  }
  function videoExit() {
    setVideo(null);
  }
  return (
    <>
      <Button className={styles.home} size={size} type="link">
        <a href="/"> Home </a>
      </Button>
      <header
        style={{
          backgroundImage:
            'url("https://image.tmdb.org/t/p/w500///' +
            data.movieInfo.poster_path +
            '")',
          opacity: '0.5',
        }}
      ></header>
      <Layout>
        <Content>
          <Row justify="center" className={styles.margin_top_wide}>
            <Col span={8} offset={2}>
              <Title level={3} className={styles.text_underline}>
                {data.movieInfo.title}
              </Title>
              <Title level={4} className={styles.margin_bottom_wide}>
                Plot
              </Title>
              <p className={(styles.description, styles.margin_bottom_narrow)}>
                {data.movieInfo.overview}
              </p>
              <img
                src={
                  'https://image.tmdb.org/t/p/w185///' +
                  data.movieInfo.poster_path
                }
                className={styles.cover_image}
                alt=""
              />
              <ul className={styles.overflow_hidden}>
                <li>
                  <p className={styles.line_height}>
                    {' '}
                    <strong>Genre:</strong> {data.movieInfo.genres}
                  </p>
                </li>
                <li>
                  <p className={styles.line_height}>
                    {' '}
                    <strong>Released:</strong>
                    {data.movieInfo.release_date}
                  </p>
                </li>
                <li>
                  <p className={styles.line_height}>
                    {' '}
                    <strong>Rated:</strong> {data.movieInfo.vote_average}
                  </p>
                </li>
                <li>
                  <p className={styles.line_height}>
                    {' '}
                    <strong>Runtime:</strong> {data.movieInfo.runtime}
                  </p>
                </li>
                <li>
                  <p className={styles.line_height}>
                    {' '}
                    <strong>Production Companies:</strong>{' '}
                    {data.movieInfo.production_companies}
                  </p>
                </li>
              </ul>
              <div className={styles.videos}>
                {videoToggle()}
                <Title level={4} className={styles.margin_bottom_narrow}>
                  Videos
                </Title>
                {/* videos */}
                {renderVideos(data.movieInfo.videos)}
              </div>
            </Col>
            <Col span={8} offset={3}>
              {/* credits */}
              <Title level={4} className={styles.margin_bottom_narrow}>
                Cast
              </Title>
              <MovieCredits credits={data.movieInfo.movieCredits} />
            </Col>
          </Row>
        </Content>
      </Layout>
    </>
  );
};

export default graphql(MOVIE_INFO)(MovieInfo);
